import { SimulateTypes } from './types';

interface ServicesProps {
  plano_id: number;
  pacote: string;
  pacote_adicional: string;
  renewal: boolean;
}

export const SimulateAll = ({ plano_id, pacote, pacote_adicional, renewal }: ServicesProps) => ({
  types: [
    SimulateTypes.GET_SIMULATE_ALL_REQUEST,
    SimulateTypes.GET_SIMULATE_ALL_SUCCESS,
    SimulateTypes.GET_SIMULATE_ALL_FAILURE,
  ],
  promise: (client: any) =>
    client.get(
      `/api/controle_crm/simulate_all_packages?plano_id=${plano_id}&pacote=${pacote}&pacote_adicional=${pacote_adicional}&renewal=${renewal}`,
    ),
});

export const serviceDadosVenda = (plano_id: number) => ({
  types: [
    SimulateTypes.GET_ADDITIONAL_SERVICES_REQUEST,
    SimulateTypes.GET_ADDITIONAL_SERVICES_SUCCESS,
    SimulateTypes.GET_ADDITIONAL_SERVICES_FAILURE,
  ],

  promise: (client: any) =>
    client.get('/api/controle_crm/optional_packages', {
      params: { plano_id, formas_pagamento_id: 1, parcelas: 1 },
    }),
});
